import { cx } from '@libs/classnames';
import { UndoIcon } from '@ui/icons/UndoIcon';

import styles from './UndoControls.module.css';

type Props = {
  className?: string;
  canUndo?: boolean;
  canRedo?: boolean;
  onUndo?: () => void;
  onRedo?: () => void;
};

// Пара «отменить / вернуть» — общая для листа ходов и расстановки задачи.
// Фон задается снаружи через --undo-controls-bg
export function UndoControls({ className, canUndo, canRedo, onUndo, onRedo }: Props) {
  return (
    <div className={cx(styles.undo_controls, className)}>
      <div className={styles.undo_controls__wrapper}>
        <div
          className={cx(styles.undo_controls__undo, { [styles.is_disabled]: !canUndo })}
          onClick={onUndo}
        >
          <UndoIcon />
        </div>
        <div
          className={cx(styles.undo_controls__redo, { [styles.is_disabled]: !canRedo })}
          onClick={onRedo}
        >
          <UndoIcon />
        </div>
      </div>
    </div>
  );
}
